// ===============================================================
// Forms — Module Layout with sub-navigation
// ===============================================================

import { Outlet, useLocation } from 'react-router-dom';
import {
  IconLayoutDashboard, IconTemplate, IconTools, IconClipboardList, IconWorld,
} from '@tabler/icons-react';
import { useFilteredNav } from '../../hooks/useFilteredNav';
import type { NavItem } from '../../types/nav';
import { brand } from '../../lib/colors';
import PageHeader from '../../components/ui/PageHeader';
import ModuleNav from '../../components/layout/ModuleNav';

const NAV_ITEMS: NavItem[] = [
  { label: 'Dashboard', path: '/forms', icon: IconLayoutDashboard, exact: true },
  { label: 'Published', path: '/forms/published', icon: IconWorld },
  { label: 'Templates', path: '/forms/templates', icon: IconTemplate, minLevel: 'editor' },
  { label: 'Builder', path: '/forms/builder', icon: IconTools, minLevel: 'editor' },
  { label: 'Responses', path: '/forms/responses', icon: IconClipboardList },
];

export default function FormsLayout() {
  const { pathname } = useLocation();
  const visibleItems = useFilteredNav('forms' as any, NAV_ITEMS);

  const isDetail = pathname.match(/\/forms\/builder\/.+/);

  const currentPage = NAV_ITEMS.find(item =>
    item.exact ? pathname === item.path : pathname.startsWith(item.path)
  );

  return (
    <div style={{ padding: '24px' }}>
      {!isDetail && (
        <>
          <PageHeader
            breadcrumbs={[{ label: 'Prepare' }, { label: 'Forms Engine' }]}
            title="Forms Engine"
            subtitle="Custom form templates, builder and response collection"
          />
          <ModuleNav items={visibleItems} accentColor={brand.blurple} />
        </>
      )}
      <Outlet />
    </div>
  );
}
